/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

const messages = defineMessages({
  typeoflanguage: {
    id: 'CoursePlan.typeoflanguage',
    defaultMessage: 'Type of language',
  },
  professional: {
    id: 'CoursePlan.professional',
    defaultMessage: 'Professional language',
  },
  general: {
    id: 'CoursePlan.general',
    defaultMessage: 'General language',
  },
  profandgen: {
    id: 'CoursePlan.profandgen',
    defaultMessage: 'Professional & General language',
  },
});

const renderSelectField = ({
  input, label, children, ...custom
}) => (
  <Select
    native
    {...input}
    {...custom}
    inputProps={{
      name: 'typeoflanguage',
      id: 'typeoflanguage-type',
    }}
    input={(
      <OutlinedInput
        name="typeoflanguage"
        labelWidth={130}
        id="outlined-typelanguage-simple"
      />
    )}
  >
    <option value="" />
    <option value="professional">
      {custom.intl.formatMessage(messages.professional)}
    </option>
    <option value="general">
      {custom.intl.formatMessage(messages.general)}
    </option>
    <option value="profandgen">
      {custom.intl.formatMessage(messages.profandgen)}
    </option>
  </Select>
);

const CoursePlanTypeOfLanguage = (props) => {
  const { intl } = props;

  return (
    <FormControl variant="outlined" style={{ width: '100%' }}>
      <InputLabel htmlFor="outlined-language-simple">
        {intl.formatMessage(messages.typeoflanguage)}
      </InputLabel>
      <Field
        name="typeoflanguage"
        component={renderSelectField}
        intl={intl}
        label="typeoflanguage-select"
      />
    </FormControl>
  );
};

CoursePlanTypeOfLanguage.propTypes = {
  intl: PropTypes.any.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return { initialValues: state.group.selectedGroup, form: name, dataform };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(injectIntl(CoursePlanTypeOfLanguage));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default NewconnectedGroupForm;
